import {useCallback, useState} from 'react';
import {useDispatch} from 'react-redux';
import {scaHelpers} from '../utils/helpers';
import {DEFAULT_MODAL_PROPS, SCAActionsConstants} from '../constants';
import {transactionActions} from '../state/actions/transaction.actions';
import {subscriptionActions} from '../state/actions/subscription.actions';

export const useExpenseRelatedData = () => {
  const dispatch = useDispatch();
  const [subscriptions, setSubscriptions] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [authWindowProps, setAuthWindowProps] = useState(DEFAULT_MODAL_PROPS);

  const handleCloseAuthModal = useCallback(() => {
    setAuthWindowProps(prev => ({...prev, open: false}));
  }, []);

  const handleAuthError = useCallback((response) => {
    scaHelpers.SCAResponseCallback({
      response,
      scaCallback: (scaProps) => setAuthWindowProps(prev => ({...prev, ...scaProps})),
    });
  }, []);

  const loadExpenseSubscriptions = useCallback((expense) => {
    const subscriptionId = expense?.subscription_id;
    if (!subscriptionId) return;

    const subscription = subscriptions.find(s => s.id === subscriptionId);
    if (subscription) return;

    dispatch(subscriptionActions.getSubscription(
      subscriptionId,
      (subscription) => setSubscriptions(prev => [...prev, subscription])
    ));
  }, [dispatch, subscriptions]);

  const loadExpenseTransactions = useCallback((expense) => {

    const transactionId = expense?.card_transaction_id;
    if (!transactionId) return;

    const transaction = transactions.find(t => t.id === transactionId);
    if (transaction) return;

    dispatch(transactionActions.getTransactionsList({
      headers: scaHelpers.getAuthHeaders(SCAActionsConstants.TRANSACTIONS_WITHIN_90_DAYS_LOADING_ACTION),
      query: {transaction_id_in: [transactionId]},
      successCallback: (response) => {
        const transaction = response[0];
        if (transaction) setTransactions(prev => ([...prev, transaction]));
        handleCloseAuthModal();
      },
      errorCallback: handleAuthError
    }));
  }, [dispatch, handleAuthError, handleCloseAuthModal, transactions]);

  const loadExpenseRelatedData = useCallback((expense) => {
    loadExpenseSubscriptions(expense);
    loadExpenseTransactions(expense);
  }, [loadExpenseSubscriptions, loadExpenseTransactions]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    subscriptions,
    transactions,
    setSubscriptions,
    setTransactions,
    loadExpenseSubscriptions,
    loadExpenseTransactions,
    loadExpenseRelatedData,
    authWindowProps,
    setAuthWindowProps,
    handleAuthError,
    handleCloseAuthModal,
  };
};
